module.exports = new __parcel__URL__("lpb.79c7d145.webp").toString();